/* global axios */

import ApiClient from './ApiClient';

class SupabaseAPI extends ApiClient {
  constructor() {
    super('integrations/supabase', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  save(payload) {
    return axios.post(this.url, { supabase_config: payload });
  }

  delete() {
    return axios.delete(this.url);
  }

  testConnection() {
    return axios.post(`${this.url}/test_connection`);
  }
}

export default new SupabaseAPI();
